import { useProductFilters } from "@nosto/preact"

export default function NoResults() {
    const { filters, removeAll } = useProductFilters()

    return (
        <div class="ns-noresults-container ns-page-width">
            <div class="ns-noresults ns-flex ns-flex-col ns-items-center ns-justify-center">
                <h2>Uh oh...</h2>
                <div class="ns-noresults-text ns-flex ns-flex-col ns-items-center ns-justify-center">
                    <p class="ns-folio-reg" role="status">There were no results found.</p>
                    <p class="ns-folio-reg">...but don't let that stand between you and fabulous knits. Try removing filters, browse our <a href="/collections/new-arrivals">newest styles</a> or find our <a href="/pages/customer-service#faq">frequently asked questions</a> on the customer service page.</p>
                    {filters?.length > 0 &&
                        <button 
                            type="button"
                            class="ns-clearall ns-folio-reg"
                            onClick={removeAll}
                        >
                            Clear filters
                        </button>
                    }
                </div>
            </div>
        </div>
    )
}
